(function() {
    function initPawsonaliseField() {
        var wrapper = document.querySelector('product-custom-property-component');
        if (!wrapper) return;

        var fields = wrapper.querySelectorAll('input, textarea');

        function findPawsonaliseSelect() {
            var selects = document.querySelectorAll('select[name^="options["]');

            for (var i = 0; i < selects.length; i++) {
                var selectName = selects[i].getAttribute('name') || '';

                if (selectName.toLowerCase().indexOf('pawsonalise') !== -1) {
                    return selects[i];
                }
            }

            return null;
        }

        function updatePawsonaliseField() {
            var select = findPawsonaliseSelect();

            if (!select) return;

            var isYes = select.value.trim().toLowerCase() === 'yes';

            if (isYes) {
                wrapper.style.display = 'block';

                fields.forEach(function(field) {
                    field.disabled = false;
                });
            } else {
                wrapper.style.display = 'none';

                fields.forEach(function(field) {
                    field.value = '';
                    field.disabled = true;
                    field.dispatchEvent(new Event('input', {
                        bubbles: true
                    }));
                    field.dispatchEvent(new Event('change', {
                        bubbles: true
                    }));
                });
            }
        }

        updatePawsonaliseField();

        document.addEventListener('change', function(event) {
            if (
                event.target.matches('select[name^="options["]') &&
                event.target.getAttribute('name').toLowerCase().indexOf('pawsonalise') !== -1
            ) {
                updatePawsonaliseField();
            }
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initPawsonaliseField);
    } else {
        initPawsonaliseField();
    }
})();